import { Tab, Tabs, Loading } from '../..';
import { DraggableList } from './DraggableList';
import { VariablesEnum } from '../const';
import { SearchBar } from '../../SearchBar';
import { useVariablesTabs } from '../hooks/useVariablesTabs';

type TabsEnum = VariablesEnum.variables | VariablesEnum.prompts;

type VariablesTabsProps = {
  isPreviewMode: boolean;
  isPromptLibraryAccess: boolean;
};

const VariablesTabs: React.FC<VariablesTabsProps> = ({
  isPreviewMode,
  isPromptLibraryAccess,
}) => {
  const {
    search,
    setSearch,
    debouncedSearch,
    loading,
    intializing,
    varibleTabs,
    filteredVariables,
    filteredPromptData,
    promptTitles,
    handleTabChange,
  } = useVariablesTabs({ isPromptLibraryAccess });

  const renderPromptsContent = () => {
    if (loading || intializing) {
      return <Loading height="100px" />;
    }

    if (!promptTitles.length) {
      return (
        <div className="text-medium text-semibold text-secondary px-4">
          {debouncedSearch
            ? 'No prompts match your search'
            : 'No prompts available'}
        </div>
      );
    }

    return (
      <DraggableList
        items={promptTitles}
        type={VariablesEnum.prompts}
        promptData={filteredPromptData}
      />
    );
  };

  return (
    <div
      className={`flex flex-col h-full ${
        isPreviewMode
          ? 'opacity-50 pointer-events-none select-none cursor-default bg-gray-100'
          : ''
      }`}
    >
      <Tabs<TabsEnum>
        tabs={varibleTabs}
        contentClassName="mt-xs flex-1 min-h-0"
        onChange={handleTabChange}
        className="flex flex-col h-full"
      >
        <Tab name={VariablesEnum.variables}>
          <div className="flex flex-col h-full gap-2">
            <SearchBar search={search} onSearch={setSearch} size="small" />
            {filteredVariables.length ? (
              <DraggableList
                items={filteredVariables}
                type={VariablesEnum.variables}
              />
            ) : (
              <div className="text-medium text-semibold text-secondary px-4">
                No variables match your search
              </div>
            )}
          </div>
        </Tab>
        {isPromptLibraryAccess && (
          <Tab name={VariablesEnum.prompts}>
            <div className="flex flex-col h-full gap-2">
              <SearchBar search={search} onSearch={setSearch} size="small" />
              {renderPromptsContent()}
            </div>
          </Tab>
        )}
      </Tabs>
    </div>
  );
};

export default VariablesTabs;
